import MicroModal from "micromodal";

document.addEventListener("turbo:load", () => {
  MicroModal.init({
    openTrigger: "data-custom-open", // [3]
    closeTrigger: "data-custom-close", // [4]
    disableScroll: true,
  });
});
